import { property } from 'lit/decorators.js'
import { html, nothing } from 'lit'

import LfdsIcon from '#components/icon/icon/lfds-icon.ts'
import { LfuiElement } from '#utils/element'
import styles from './lfds-checkbox-group.css.ts'

/**
 * @name LfdsCheckboxGroup
 * @tag lfds-checkbox-group
 *
 * @status beta
 *
 * @slot label - The group label, rendered as a `<legend>`. Screen readers announce this as group context when entering the fieldset.
 * @slot - Default slot for `lfds-checkbox` elements.
 */
export default class LfdsCheckboxGroup extends LfuiElement {
	static styles = [LfuiElement.styles, styles]

	@property({ attribute: 'help-text' }) helpText: string
	@property({ attribute: 'validation-message' }) validationMessage: string

	// Stable IDs so the fieldset can reference both via aria-describedby
	#helpId = `lfds-cbg-help-${Math.random().toString(36).slice(2, 8)}`
	#validationId = `lfds-cbg-validation-${Math.random().toString(36).slice(2, 8)}`

	constructor() {
		super()
		LfdsIcon.preload('alert', 24)
	}

	render() {
		return html`
			<fieldset
				aria-describedby=${[
					this.helpText ? this.#helpId : null,
					this.validationMessage ? this.#validationId : null
				]
					.filter(Boolean)
					.join(' ') || nothing}
			>
				<legend>
					<slot name="label"></slot>
				</legend>

				${this.helpText
					? html`<span id=${this.#helpId} class="help">${this.helpText}</span>`
					: nothing}

				<div class="checkboxes">
					<slot></slot>
				</div>

				${this.validationMessage
					? html`
							<div
								id=${this.#validationId}
								class="validation"
								role="alert"
								aria-atomic="true"
							>
								<span class="icon">
									<lfds-icon
										icon-id="alert"
										size="24"
										color="currentcolor"
									></lfds-icon>
								</span>
								<span>${this.validationMessage}</span>
							</div>
						`
					: nothing}
			</fieldset>
		`
	}
}
